// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".waiter-judged-tab[data-v-143f4412]{position:relative;width:100%;min-height:240px}.waiter-judged-tab .point[data-v-143f4412]{font-weight:700;font-size:20px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
